import { useEffect } from "react";
import { useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import { useReviewTime } from "@/hooks/useReviewTime";

/**
 * PWA Badge Update Component
 * This component updates the app badge with the current review count
 * It should be included at the top level of your app
 */
export const PwaBadgeUpdater = () => {
  const reviewTime = useReviewTime();

  // Get the current review count
  const reviewCount = useQuery(api.aggregates.toReviewCount.total, {
    reviewTime,
  });

  // Update the badge when the count changes
  useEffect(() => {
    if (typeof reviewCount !== "number") return;

    // Check if the Badge API is supported
    if (typeof navigator !== "undefined" && "setAppBadge" in navigator) {
      try {
        if (reviewCount > 0) {
          navigator.setAppBadge(reviewCount).catch((err: unknown) => {
            console.error("Error setting badge:", err);
          });
        } else {
          navigator.clearAppBadge().catch((err: unknown) => {
            console.error("Error clearing badge:", err);
          });
        }
      } catch (error) {
        console.error("Error updating badge:", error);
      }
    }
  }, [reviewCount]);

  // This component doesn't render anything
  return null;
};
